module.exports = __webpack_public_path__ + "img/development.d9a3430c.svg";